import { RepositoryFactory } from "repositories/factory";
import { AUTO_RENEWAL } from "models/subscription";
import { AscmuSubscription } from "models/ascmu-subscription";

const AscmuSubscriptionsRepository = RepositoryFactory.get("ascmu-subscriptions");
const MabeeemlMonitoringSettingsRepository = RepositoryFactory.get("mabeeeml-monitoring-devices");

/* フォームアイテム */
class AscmuSubscriptionsController {
  constructor() {
    this._ascmuSubscription = null;
    this._organizationId = null;
    this._projectId = null;
    this._monitoringDeviceId = null;
    this._autoRenewal = AUTO_RENEWAL.OFF;
  }

  get ascmuSubscription() {
    return this._ascmuSubscription;
  }

  set ascmuSubscription(value) {
    this._ascmuSubscription = value;
  }

  get projectId() {
    return this._projectId;
  }

  set projectId(value) {
    this._projectId = value;
  }

  get monitoringDeviceId() {
    return this._monitoringDeviceId;
  }

  set monitoringDeviceId(value) {
    this._monitoringDeviceId = value;
  }

  get autoRenewal() {
    return this._autoRenewal;
  }

  set autoRenewal(value) {
    this._autoRenewal = value;
  }

  /* 算出プロパティ */
  isActive() {
    let res = false;
    if (
      // 自動更新フラグがことなる
      this.ascmuSubscription && this.ascmuSubscription.isActive()
    ) {
      res = true;
    }
    return res;
  }

  isAscmuSubscriptionStore() {
    let res = false;
    // 監視デバイスが設定されていなければ登録は行われない
    if (!this.monitoringDeviceId) {
      return res;
    }

    // 監視デバイスが設定されている場合は、サブスクリプションの状態をチェックする。
    if (!this.ascmuSubscription) {
      // サブスクリプションが存在しない
      res = true;
    } else if (!this.ascmuSubscription.isActive()) {
      // サブスクリプションが有効期限切れ
      res = true;
    }
    return res;
  }

  // サブスクリプションの更新は、サブスクリプションが有効な期間しか実施不可
  // 期限切れになった場合は、生成
  isAscmuSubscriptionUpdate() {
    let res = false;
    if (
      // 自動更新フラグがことなる
      this.ascmuSubscription && this.ascmuSubscription.isActive()
      && this.ascmuSubscription.autoRenewal !== this.autoRenewal
    ) {
      res = true;
    }
    return res;
  }

  autoRenewalText() {
    let res = "";
    if (this.ascmuSubscription && this.ascmuSubscription.isActive()) {
      // サブスクリプションが有効期限切れ
      if (this.autoRenewal === AUTO_RENEWAL.ON) {
        res = `更新日：${this.ascmuSubscription.renewalAtText()}`;
      } else {
        res = `利用可能期間：${this.ascmuSubscription.expiseAtText()} まで`;
      }
    }
    return res;
  }

  /* イベントハンドラ */
  clearSubscription() {
    this.ascmuSubscription = null;
    this.projectId = null;
    this.monitoringDeviceId = null;
  }

  /* 初期化・登録処理 */
  static async createInstance(projectId, monitoringDeviceId = null) {
    // 初期化(DBの値をフォーム反映)
    const ascmuSubscriptionsController = new AscmuSubscriptionsController();
    ascmuSubscriptionsController.projectId = projectId;
    ascmuSubscriptionsController.monitoringDeviceId = monitoringDeviceId;
    let ascmuSubscription = null;

    // データが存在しない場合
    if (!monitoringDeviceId) {
      ascmuSubscription = new AscmuSubscription();
      ascmuSubscription.autoRenewal = AUTO_RENEWAL.ON;
    } else {
      const ascmuSbuscriptionHistory
      = await MabeeemlMonitoringSettingsRepository.getAscmuSubscriptionHistory(
        projectId,
        monitoringDeviceId,
      );
      if (ascmuSbuscriptionHistory.length > 0) {
        [ascmuSubscription] = ascmuSbuscriptionHistory;
      }
    }
    ascmuSubscriptionsController.ascmuSubscription = ascmuSubscription;
    if (ascmuSubscription) {
      ascmuSubscriptionsController.autoRenewal = ascmuSubscription.autoRenewal;
    }
    return ascmuSubscriptionsController;
  }

  createAscmuSubscription() {
    const ascmuSubscription = this.ascmuSubscription.copy();
    ascmuSubscription.autoRenewal = this.autoRenewal;
    return ascmuSubscription;
  }

  async create() {
    if (this.isAscmuSubscriptionStore()) {
      this.ascmuSubscription
        = await MabeeemlMonitoringSettingsRepository.createAscmuSubscription(
          this.projectId,
          this.monitoringDeviceId,
          this.autoRenewal,
        );
    }
  }

  // 登録/更新
  async update() {
    console.log("UPDSTE");
    console.log(this.createAscmuSubscription());
    console.log(this.isAscmuSubscriptionUpdate());
    if (this.isAscmuSubscriptionUpdate()) {
      this.ascmuSubscription = await AscmuSubscriptionsRepository.update(
        this.createAscmuSubscription(),
      );
    }
  }
}

export {
  AscmuSubscriptionsController,
};
